export default __webpack_public_path__ + "static/media/logo.1f0644a3.png";